class StylingAdvicePanel extends Panel {
  transitionFrom(previousState, newState, triggerElement, previousPanel) {
    // super.transitionFrom(previousState, newState, triggerElement, previousPanel);
    this.activate();
    requestAnimationFrame(() => {
      if (previousState === 'idle') {
        actions.openRightBottomNav().then(() => {
          window.trapFocus(this, this.defaultFocus, triggerElement);
        });
      } else if (previousPanel) {
        window.trapFocus(this, this.defaultFocus, triggerElement);
        previousPanel.deactivate();
      }
    });
  }
}
customElements.define('styling-advice-panel', StylingAdvicePanel);
